import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { getFirestore, doc, setDoc } from "firebase/firestore";

export interface FCMTokenData {
    token: string;
    userId: string;
}

const firebaseConfig = {
    apiKey: "AIzaSyDj17onCXCfiIVoiBQ_XZrBIkBldew53j4",
    authDomain: "fir-c3e52.firebaseapp.com",
    projectId: "fir-c3e52",
    storageBucket: "fir-c3e52.firebasestorage.app",
    messagingSenderId: "575472676529",
    appId: "1:575472676529:web:08e875295d4ec72f01bc90"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const db = getFirestore(app);


const vapidKey = "BJUAeJ119QiGUCy20z9kWjP29Kzt8qUtcOw_UaWAIXC8txgdg41Gpc4jsUkhyVGRGp-If5_hRQd9_DSymZjWjHw";

async function saveTokenToFirestore(token: string | null, userId: string) {
    if (!token) return;
    try {
        await setDoc(doc(db, "fcmTokens", userId), { token });
        console.log("Token salvato su Firestore ✅");
    } catch (e) {
        console.error("Errore salvataggio token:", e);
    }
}

export async function requestPermissionAndToken(): Promise<FCMTokenData | null> {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        console.warn('Permesso notifiche negato');
        return null;
    }
    let swRegistration: ServiceWorkerRegistration | undefined;
    if ('serviceWorker' in navigator) {
        try {
            swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            console.log('Service worker registered for FCM:', swRegistration);
        } catch (e) {
            console.warn('Service worker registration for FCM failed:', e);
        }
    }

    try {
        const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: swRegistration });
        const userId = (typeof crypto !== 'undefined' && typeof (crypto as any).randomUUID === 'function') ? (crypto as any).randomUUID() : String(Date.now()); // usa uid Firebase Auth se disponibile
        await saveTokenToFirestore(token, userId);
        return { token, userId };
    } catch (err) {
        console.error('Errore ottenimento token FCM:', err);
        return null;
    }
}

export { messaging, db, saveTokenToFirestore, setDoc, doc };

const FirebaseService = {
    requestPermissionAndToken,
    saveTokenToFirestore,
    messaging,
    db,
};

export default FirebaseService;
